import React, {Component} from 'react';
import {MODE_SOLUTION, TYPE_THEMATIQUE} from "../../../../constants";
import "./BtnValidate.scss";

class BtnValidate extends Component {
  render() {
    const {mode, type, validateChoices, showComments, showSolution} = this.props;
    let text = "Valider";
    let className = "btn-success";

    // Display button only if it's not solution mode
    if (mode === MODE_SOLUTION) {
      return null;
    }

    // If mode is thematique and the solution is displayed, change btn text to "Next"
    if (type === TYPE_THEMATIQUE && showComments && showSolution) {
      text = "Suivant";
      className = "btn-primary";
    }

    return (
      <button onClick={validateChoices} className={"btn btn-valid " + className}>{text}</button>
    );
  }
}

export default BtnValidate;
